import { render } from "./add-course-modal.vue?vue&type=template&id=0fd1331e"
import script from "./add-course-modal.vue?vue&type=script&lang=js"
export * from "./add-course-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__